import IconBase, { IconBaseProps } from "./IconBase";

const QRIconLarge = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g fill="none" fillRule="evenodd">
      <rect
        stroke="currentColor"
        strokeWidth="2"
        x="1"
        y="1"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        stroke="currentColor"
        strokeWidth="2"
        x="1"
        y="12"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        stroke="currentColor"
        strokeWidth="2"
        x="12"
        y="1"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        fill="currentColor"
        x="3.25"
        y="3.25"
        width="2.5"
        height="2.5"
        rx=".5"
      />
      <rect
        fill="currentColor"
        x="3.25"
        y="14.25"
        width="2.5"
        height="2.5"
        rx=".5"
      />
      <rect
        fill="currentColor"
        x="14.25"
        y="3.25"
        width="2.5"
        height="2.5"
        rx=".5"
      />
      <rect fill="currentColor" x="11" y="11" width="2" height="2" rx=".5" />
      <rect fill="currentColor" x="11" y="18" width="2" height="2" rx=".5" />
      <rect fill="currentColor" x="11" y="14.5" width="2" height="5" rx=".5" />
      <rect fill="currentColor" x="14.5" y="11" width="2" height="2" rx=".5" />
      <rect fill="currentColor" x="14.5" y="18" width="5" height="2" rx=".5" />
      <rect
        fill="currentColor"
        x="14.5"
        y="11.5"
        width="2"
        height="5"
        rx=".5"
      />
      <rect fill="currentColor" x="18" y="11" width="2" height="2" rx=".5" />
      <rect fill="currentColor" x="18" y="18" width="2" height="2" rx=".5" />
      <rect fill="currentColor" x="15" y="14.5" width="5" height="2" rx=".5" />
    </g>
  </IconBase>
);

export default QRIconLarge;
